import { formatDate } from "../../../../../../../utils/date";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import {
  FestivalInterviewContentInfo,
  FestivalInterviewContentText,
  FestivalInterviewContentWrapper,
} from "./style";

const RabbitFestivalInterviewContent = () => {
  const { interview } = useRabbitFestivalContext();

  return (
    <FestivalInterviewContentWrapper>
      <div className="title">우승자 인터뷰</div>
      <FestivalInterviewContentInfo>
        <div className="date">{formatDate(interview?.createdAt || "")}</div>
        <div className="nickname">{interview?.mainTitle}</div>
      </FestivalInterviewContentInfo>
      <FestivalInterviewContentText>
        {interview && (
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: interview.contentHtml }}
          />
        )}
      </FestivalInterviewContentText>
    </FestivalInterviewContentWrapper>
  );
};

export default RabbitFestivalInterviewContent;
